/**
 *
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://146.56.218.109:18086/wechat/index.html
 *
 * Copyright 2024-2031 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 */
document.addEventListener("DOMContentLoaded", function () {
  // 倒计时
  function getRandomNum(min, max) {
    return Math.floor(Math.random() * (max - min)) + min;
  }

  let endTimeG;

  function cutDownTime() {
    let nowTime = new Date();
    let endTime = new Date(endTimeG);

    let leftTime = endTime.getTime() - nowTime.getTime();
    if (leftTime < 0) {
      setupNewCountdown();
      leftTime = 0;
    }
    let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
      leftM = Math.floor((leftTime / (1000 * 60)) % 60),
      leftS = Math.floor((leftTime / 1000) % 60);
    leftH = leftH >= 10 ? leftH : "0" + leftH;
    leftM = leftM >= 10 ? leftM : "0" + leftM;
    leftS = leftS >= 10 ? leftS : "0" + leftS;

    return {
      hour: leftH,
      minute: leftM,
      second: leftS,
    };
  }
  function setupNewCountdown() {
    const randomHour = getRandomNum(1, 9);
    const currentTime = new Date();
    endTimeG = currentTime.setHours(currentTime.getHours() + randomHour);
  }
  let intervalId;

  function getCutDownTime() {
    setupNewCountdown();
    if (intervalId) clearInterval(intervalId);
    intervalId = setInterval(function () {
      let cutDownTimeText = cutDownTime();
      $(".sp_top_cut_down .sp_left_view .sp_hour").html(cutDownTimeText.hour);
      $(".sp_top_cut_down .sp_left_view .sp_minute").html(
        cutDownTimeText.minute
      );
      $(".sp_top_cut_down .sp_left_view .sp_second").html(
        cutDownTimeText.second
      );
    }, 1000);
  }

  getCutDownTime();

  let spImgList = [
    "https://cdn.shopify.com/s/files/1/0737/4018/9912/files/20250610-p1.jpg",
    "https://cdn.shopify.com/s/files/1/0737/4018/9912/files/20250610-p2.jpg",
    "https://cdn.shopify.com/s/files/1/0737/4018/9912/files/20250610-p3.jpg",
    "https://cdn.shopify.com/s/files/1/0737/4018/9912/files/20250610-p4.jpg",
    "https://cdn.shopify.com/s/files/1/0737/4018/9912/files/20250610-p5.jpg",
    "https://cdn.shopify.com/s/files/1/0737/4018/9912/files/20250610-p6.jpg",
    "https://cdn.shopify.com/s/files/1/0737/4018/9912/files/20250610-p7.jpg",
    "https://cdn.shopify.com/s/files/1/0737/4018/9912/files/20250610-p8.jpg",
    "https://cdn.shopify.com/s/files/1/0737/4018/9912/files/20250610-p9.jpg",
    "https://cdn.shopify.com/s/files/1/0737/4018/9912/files/20250610-p10.jpg",
    "https://cdn.shopify.com/s/files/1/0737/4018/9912/files/20250610-p11.jpg",
    "https://cdn.shopify.com/s/files/1/0737/4018/9912/files/20250610-p12.jpg",
    "https://cdn.shopify.com/s/files/1/0737/4018/9912/files/20250610-p13.jpg",
    "https://cdn.shopify.com/s/files/1/0737/4018/9912/files/20250610-p14.jpg",
    "https://cdn.shopify.com/s/files/1/0737/4018/9912/files/20250610-p15.jpg",
    "https://cdn.shopify.com/s/files/1/0737/4018/9912/files/20250610-p16.jpg",
    "https://cdn.shopify.com/s/files/1/0737/4018/9912/files/20250610-p17.jpg",
    "https://cdn.shopify.com/s/files/1/0737/4018/9912/files/20250610-p18.jpg",
    "https://cdn.shopify.com/s/files/1/0737/4018/9912/files/20250610-p19.jpg",
    "https://cdn.shopify.com/s/files/1/0737/4018/9912/files/20250610-p20.jpg",
    "https://cdn.shopify.com/s/files/1/0737/4018/9912/files/20250610-p21.jpg",
    "https://cdn.shopify.com/s/files/1/0737/4018/9912/files/20250610-p22.jpg",
    "https://cdn.shopify.com/s/files/1/0737/4018/9912/files/20250610-p23.jpg",
    // "https://cdn.shopify.com/s/files/1/0737/4018/9912/files/20250610-p24.jpg",
    "https://cdn.shopify.com/s/files/1/0737/4018/9912/files/20250610-p25.jpg",
    "https://cdn.shopify.com/s/files/1/0737/4018/9912/files/20250610-p26.jpg",
    "https://cdn.shopify.com/s/files/1/0737/4018/9912/files/20250610-p27.jpg",
    "https://cdn.shopify.com/s/files/1/0737/4018/9912/files/20250610-p28.jpg",
    "https://cdn.shopify.com/s/files/1/0737/4018/9912/files/20250610-p29.jpg",
    "https://cdn.shopify.com/s/files/1/0737/4018/9912/files/20250610-p30.jpg",
    "https://cdn.shopify.com/s/files/1/0737/4018/9912/files/20250610-p31.jpg",
    "https://cdn.shopify.com/s/files/1/0737/4018/9912/files/20250610-p32.jpg",

    "https://cdn.shopify.com/s/files/1/0737/4018/9912/files/20250610-b1.png",
    "https://cdn.shopify.com/s/files/1/0737/4018/9912/files/20250610-b2.png",
    "https://cdn.shopify.com/s/files/1/0737/4018/9912/files/20250610-b3.png",

    "https://cdn.shopify.com/s/files/1/0737/4018/9912/files/20250610-c1.png",
    "https://cdn.shopify.com/s/files/1/0737/4018/9912/files/20250610-c2.png",
    "https://cdn.shopify.com/s/files/1/0737/4018/9912/files/20250610-c3.png",

    "https://cdn.shopify.com/s/files/1/0737/4018/9912/files/20250610-1.png",
    "https://cdn.shopify.com/s/files/1/0737/4018/9912/files/20250610-2.png",
    "https://cdn.shopify.com/s/files/1/0737/4018/9912/files/20250610-3.png",
    "https://cdn.shopify.com/s/files/1/0737/4018/9912/files/20250610-4.png",
    "https://cdn.shopify.com/s/files/1/0737/4018/9912/files/20250610-5.png",
    "https://cdn.shopify.com/s/files/1/0737/4018/9912/files/20250610-6.png",
  ];

  new Swiper("#sp-swiper2", {
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
    },
    spaceBetween: 0,
    slidesPerView: "auto",
    centeredSlides: true,
    loop: true,
    pagination: {
      el: ".sp-pagination1",
      clickable: true,
    },
  });
  new Swiper(".sp-swiper1", {
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
      delay: 1,
    },
    spaceBetween: 0,
    slidesPerView: "auto",
    loop: true,
    pagination: {
      el: ".sp-pagination2",
      clickable: true,
    },
    speed: 6000,
  });

  new Swiper(".sp-swiper3", {
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
    },
    slidesPerView: "auto",
    centeredSlides: true,
    effect: "coverflow",
    slidesPerView: 1.2, // 设置slider容器能够同时显示的slides数量(carousel模式)
    centeredSlides: true,
    coverflowEffect: {
      rotate: 0,
      stretch: 680,
      depth: 240,
      modifier: 1,
      slideShadows: false,
    },
    pagination: {
      el: ".sp-pagination3",
      clickable: true,
    },
    loop: true,
  });

  function mainRender() {
    $(function () {
      $("#root").css("zoom", "normal");
      let scale = document.body.clientWidth / 1080;
      $("#root").css("zoom", scale);

      window.addEventListener(
        "resize",
        (function () {
          var timer;
          return function () {
            if (timer) clearTimeout(timer);
            timer = setTimeout(function () {
              $("#root").css("zoom", "normal");
              let scale = document.body.clientWidth / 1080;
              $("#root").css("zoom", scale);
            }, 100);
          };
        })()
      );
    });

    function lazyLoadImages() {
      // 懒加载
      const images = document.querySelectorAll(".lazy-load"); // 获取所有需要懒加载的图片
      const config = {
        rootMargin: "0px 0px 1300px 0px",
        threshold: 0,
      };

      const lazyLoadObserver = new IntersectionObserver(function (
        entries,
        observer
      ) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            // 当图片进入视口时
            const image = entry.target;
            const dataSrc = image.getAttribute("data-src");
            image.src = dataSrc; // 将data-src属性的值设置为图片的实际地址
            lazyLoadObserver.unobserve(image); // 停止观察该图片
          }
        });
      },
      config);

      images.forEach(function (image) {
        lazyLoadObserver.observe(image); // 开始观察每个图片
      });
    }

    function preloadImages(imageArray) {
      // 预加载
      // 检查数组数据结构
      if (Array.isArray(imageArray[0])) {
        // 处理二维数组
        imageArray.forEach((subArray) => {
          subArray.forEach((url) => {
            const img = new Image();
            img.src = url;
          });
        });
      } else {
        // 处理一维数组
        imageArray.forEach((url) => {
          const img = new Image();
          img.src = url;
        });
      }
    }

    lazyLoadImages();

    preloadImages(spImgList);

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]');
    links.forEach(function (link) {
      link.addEventListener("click", function (event) {
        event.preventDefault(); // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById("shopping"); // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop;
        let _topHeight =
          $(".time-part").height() + $(".sp-header-top").height();
        window.scroll({
          top:
            offsetTop * $("div#root").css("zoom") -
            _topHeight * $("div#root").css("zoom") +
            10,
          behavior: "smooth", // 使用 smooth 实现平滑滚动
        }); // 方式二
      });
    });

    // IOS字体多了间距的处理 给节点添加 sp_system 类名
    // 判断当前用户是安卓端还是iOS端
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    var isAndroid = /android/i.test(userAgent);
    var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
    var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent); // 添加了对 "Iron" 关键词的判断

    if (isAndroid) {
      console.log("Android");
    } else if (isIOS) {
      console.log("iOS");
    } else if (isPC) {
      console.log("PC");
    } else {
      $(".sp_system").css("letter-spacing", "-4px");
    }
  }

  mainRender();

  let sp_price1 = 14.99;
  let sp_price2 = 29.99;

  function calcTotal(price, num) {
    let result = Number(price) * Number(num);
    return result.toFixed(2);
  }

  $(".sp-reduce").click(function () {
    let input = $(this).siblings("input")[0];
    let num = Number(input.value) - 1;
    if (num > 0) {
      input.value = num;
    }
    $("#sp_price1").html(calcTotal(sp_price1, input.value));
    $("#sp_price2").html(calcTotal(sp_price2, input.value));
  });
  $(".sp-add").click(function () {
    let input = $(this).siblings("input")[0];
    let num = Number(input.value) + 1;
    input.value = num;
    $("#sp_price1").html(calcTotal(sp_price1, input.value));
    $("#sp_price2").html(calcTotal(sp_price2, input.value));
  });

  let _sptext = [
    `Kaufen Sie einen weiteren Artikel und erhalten Sie <span class="sp-span sp-color">8% Rabatt</span>`,
    `Kaufen Sie einen weiteren Artikel und erhalten Sie <span class="sp-span sp-color">10% Rabatt</span>`,
    `Kaufen Sie einen weiteren Artikel und erhalten Sie <span class="sp-span sp-color">15% Rabatt</span>`,
    `Genießen <span class="sp-span sp-color">20% Rabatt</span>`,
  ];
  let prods = window.product
  $(".sp-option").click(function () {
    $(this).toggleClass("active");
    
    let colorOptions = $(this).attr("data-index");

    let _selected = $(".product-part").find(".sp-option.active");

    let _index = colorOptions;
    if (_selected.length == 2) {
      $(".sp-select").html(
        `<p class="sp-color">` +
          _selected.length +
          ` Artikel ausgewählt</p>` +
          _sptext[1]
      );
    } else if (_selected.length == 3) {
      $(".sp-select").html(
        `<p class="sp-color">` +
          _selected.length +
          ` Artikel ausgewählt</p>` +
          _sptext[2]
      );
    } else if (_selected.length == 1) {
      $(".sp-select").html(
        `<p class="sp-color">` +
          _selected.length +
          ` Artikel ausgewählt</p>` +
          _sptext[0]
      );
    } else {
      $(".sp-select").html(
        `<p class="sp-color">` +
          _selected.length +
          ` Artikel ausgewählt</p>` +
          _sptext[3]
      );
    }
    if(_selected.length == 0){
      $(".product-part .sp-tip").hide()
    }else{
      $(".product-part .sp-tip").show()
    }
    changePrice()
    $(".product-part .sp-img-p")[0].src = spImgList[_index];
  });
  function getCur(id){
    return prods.filter(item=> item.id == id )[0]
  }
  function changePrice(){
    let _selected = $(".product-part").find(".sp-option.active");
    let price = (prods[0].price / 100).toFixed(2)
    let compare = (prods[0].compare_at_price  / 100).toFixed(2)
    let perPrice = (prods[0].price / 100).toFixed(2)
    let totalPrice = 0
    let totalComprice = 0
    $('.product-part  .sp-option.active').each(function () {
    // 在这里你可以操作每个元素
    var id = $(this).attr('data-id'); // 获取当前元素的ID
    totalPrice = getCur(id).price + totalPrice
    totalComprice = getCur(id).compare_at_price + totalComprice
    });
    console.log(totalPrice)
    if(_selected.length == 2){
      price = (Math.floor(totalPrice * 0.92 ) / 100).toFixed(2)
    }else if(_selected.length == 3){
      price = (Math.floor(totalPrice * 0.90 ) / 100).toFixed(2)
    }else if(_selected.length > 3){
      price = (Math.floor(totalPrice * 0.85 ) / 100).toFixed(2)
    }
    perPrice = (price / _selected.length ).toFixed(2)
    compare = (totalComprice / 100).toFixed(2)
    if(_selected.length == 0){
       price = (prods[0].price / 100).toFixed(2)
       compare = (prods[0].compare_at_price  / 100).toFixed(2)
      perPrice = (prods[0].price / 100).toFixed(2)
    }
    price = (price + '').replace('.', ',')
    compare = (compare + '').replace('.', ',')
   $('#sp_price1').html(price)
    $('#sp_price2').html(compare)
    $('.sp-d2').html(perPrice)
  }
  $('.sp-btn-style').click(function () {
  let _selectId = []
  let str = ''
  $('.product-part  .sp-option.active').each(function () {
    // 在这里你可以操作每个元素
    var id = $(this).attr('data-id'); // 获取当前元素的ID
    console.log(id); // 打印或以其他方式使用ID
    _selectId.push(id)
    str = str + id + ':' + 1 + ','
  });
  if (str.endsWith(",")) { // 判断字符串是否以逗号结尾
    str = str.substring(0, str.length - 1); // 使用substring方法去掉最后一个字符
  }
  window.location.href = '/cart/' + str
})

  $(function () {
    // 购物车加购动效
    $(".cart-btn").click(function () {
      $(this).children("img").addClass("on");
      $(".sp-header-top .sp-cart .num").show();
      setTimeout(function () {
        $(".cart-btn").children("img").removeClass("on");
      }, 500);
      $(".sp-header-top .sp-cart").addClass("on");
      setTimeout(function () {
        $(".sp-header-top .sp-cart").removeClass("on");
      }, 500);
    });

    let initNum = 0;
    $(".product-part .cart-btn").click(function () {
      let spNum = $(".product-part #calcNumber")[0].value;
      initNum += Number(spNum);

      // $("#calcNumber").val(1);
      $("#cardNum").html(initNum);
      $("#cardNum").removeClass("sp-gray");
      // handleAddToCart(initNum);

      var img = $(".product-part .sp-img-p");
      // var img = $(".product-part .sp-swiper .swiper-slide-active .sp-img");

      var flyer = img[0].cloneNode(true);
      flyer.classList.add("sp_clone");

      $(".product-part").append(flyer);
      $(".sp_clone").css({
        width: img[0].width,
        height: img[0].height,
        background: "#e7e9ef",
        position: "fixed",
        top: img[0].offsetTop,
        left: img.offset().left,
        "z-index": "99",
      });

      let finish = $(".sp-cart");
      $(".sp_clone").animate(
        {
          // top: finish[0].offsetTop,
          top: finish[0].offsetTop + $(".time-part").height(),
          left: finish[0].offsetLeft + finish.width() / 2,
          width: 50, // 结束时的大小，根据需要调整
          height: 50, // 结束时的大小，根据需要调整
          opacity: 0.4,
        },
        500,
        "linear",
        function () {
          $(this).animate(
            {
              width: 0,
              height: 0,
              opacity: 0,
            },
            0,
            function () {
              $(this).detach();
            }
          );
        }
      );
    });
  });

  // 标题文本渐出
  const graduallyList = document.getElementsByClassName("gradually");
  for (let gradually of graduallyList) {
    const spans = gradually.querySelectorAll("span");
    const paragraph = gradually.querySelector(".sp-sub-title");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // 给每个 span 和 i 动画
            spans.forEach((span, index) => {
              span.style.animation = `swift-up-fade 0.5s ease forwards`;
              span.style.animationDelay = `${index * 0.1}s`;

              const i = span.querySelector("i");
              if (i) {
                i.style.animation = `swift-up-fade 0.5s ease forwards`;
                i.style.animationDelay = `${index * 0.1}s`;
              }
            });

            // 段落
            const totalDelay = spans.length * 0.1 + 0.3;
            if (paragraph) {
              paragraph.style.animation = `swift-up-fade 0.5s ease forwards`;
              paragraph.style.animationDelay = `${totalDelay}s`;
            }

            observer.unobserve(gradually);
          }
        });
      },
      {
        threshold: 0.3,
      }
    );
    observer.observe(gradually);
  }
});
